export default import.meta.ROLLDOWN_FILE_URL_rPhdecqsXn$1yBUS8of3NQ